export const objToSelectItems = (obj) => {
    let arr = [];
    for (let item in obj) {
        if (obj[item] !== null) arr.push({ key: item.toLowerCase(), value: obj[item] });
    }

    return arr;
};
